import React from 'react';
import { Button, Form } from 'react-bootstrap';

export default function MonthPickerComponent({ value, onChange, label, className = '' }) {
  const formatMonth = (monthString) => {
    if (!monthString) return { year: new Date().getFullYear(), month: new Date().getMonth() };
    const [year, month] = monthString.split('-').map(Number);
    return { year, month };
  };

  const formatMonthString = (year, month) => {
    return `${year}-${String(month).padStart(2, '0')}`;
  };

  const { year, month } = formatMonth(value);
  const currentMonthString = formatMonthString(year, month);

  const handlePrevious = () => {
    let newYear = year;
    let newMonth = month - 1;
    if (newMonth < 1) {
      newMonth = 12;
      newYear -= 1;
    }
    onChange(formatMonthString(newYear, newMonth));
  };

  const handleNext = () => {
    let newYear = year;
    let newMonth = month + 1;
    if (newMonth > 12) {
      newMonth = 1;
      newYear += 1;
    }
    onChange(formatMonthString(newYear, newMonth));
  };

  const displayText = `${month}/${year}`;

  return (
    <div className={className}>
      {label && <Form.Label>{label}</Form.Label>}
      <div className="d-flex align-items-center gap-2">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={handlePrevious}
          className="d-flex align-items-center justify-content-center"
          style={{ width: '36px', height: '36px' }}
        >
          <i
            className="material-icons"
            style={{ fontSize: '18px' }}
          >
            chevron_left
          </i>
        </Button>
        <Form.Control
          type="text"
          value={displayText}
          readOnly
          className="text-center"
          style={{ maxWidth: '120px' }}
        />
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={handleNext}
          className="d-flex align-items-center justify-content-center"
          style={{ width: '36px', height: '36px' }}
        >
          <i
            className="material-icons"
            style={{ fontSize: '18px' }}
          >
            chevron_right
          </i>
        </Button>
      </div>
    </div>
  );
}
